import { parse } from 'qs'
import { getLocale } from '../../interstitials/components/learn-more/utils'
import fetchContent, { FetchContentParams } from '../../newInterstitials/utilities/fetchContent'

export async function startPrequalification(
  params: FetchContentParams,
  language: string,
  country: string,
  show_button: boolean | (() => void)
) {
  const locale = getLocale({ language, country })
  const urlParams = parse(window.location.search, { ignoreQueryPrefix: true })

  // When KP lib starts prequal, background request is sent, we need to show some loader
  // and if KP fails then this will proceed after the delay
  if (urlParams.delay) {
    await new Promise<void>(resolve => {
      setTimeout(resolve, Number(urlParams.delay || 0))
    })
  }

  const data = await fetchContent({ ...params, locale, path: 'v1/prequalification/start' })
  if (data?.prequalification_client_uri !== null) {
    const url = new URL(data.prequalification_client_uri)
    url.searchParams.set('locale', locale)
    if (show_button !== undefined) {
      url.searchParams.set('show_close_button', show_button instanceof Function ? 'true' : 'false')
    }
    window.location.replace(url.toString())
  }
}
